// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ErrIh","content":"styles_content__g3AjK","row":"styles_row__3qp6h","footer":"styles_footer__1qH8z","phraseLength":"styles_phraseLength__bhLKU"};